// removed by extract-text-webpack-plugin
module.exports = {"GuideMenu":"_3L5jUdXD3O7H9EuN7BPXZp","container":"_3y0c3-agtpt56UrDUr2hE1","openingHoursMessage":"_2TuTKWO0HhcIW0t6KxvIOt","list":"_0BlrvdNJR0YW2er78zaA","menuItem":"_3f1QW70HvHOyDeTl_5gMNu","grower":"_3EAFSt4E17Qa8W_6FQhQiO","icon":"_21-RfP3U0y9tuSNds8qj3l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GuideMenu/GuideMenu.css
// module id = 489
// module chunks = 8